import React, { useState} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {IconButton} from "@mui/material";
import {useTheme} from "../../contexts/theme";
import {ClipGroup} from "../../types/mamTypes";
import CardClipComponent from "../CommonComponents/CardClipComponent/CardClipComponent";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import AutoAwesomeMotionOutlinedIcon from "@mui/icons-material/AutoAwesomeMotionOutlined";
import Grid from "@mui/material/Grid";
import StyledPopup from "../CommonComponents/StyledPopup/StyledPopup";
import {useMamInformation} from "../../contexts/MamInformation";
import ClipComponent from "./ClipComponent";
import {useClipMamSelected} from "../../contexts/clipMamSelected";
import ErrorSnackBar from "../CommonComponents/ErrorSnackBar/ErrorSnackBar";
import ContentCardSkeleton from "./ContentCardSkeletonComponent/ContentCardSkeleton";

interface groupClipsProps {
    groupClip: ClipGroup;
    selectedGroupClipdId?: string;
    handleVideoPlayerUrl: (url: string) => void;
    handleOpenVideoPlayerUrl: (open: boolean) => void;
    deleteGroupClip : (idClipGroups: string) => void;
    deleteClip : (idClipGroups: string) => void;
    onCollapseClipsGroupOpen: (competition: string, event_id: string, clipGroup_id: string, openEvent: boolean) => void;
    addClipGroup : (idClipGroup: string) => void;
    loadClip: boolean
}


export default function GroupClip({groupClip, handleOpenVideoPlayerUrl, handleVideoPlayerUrl, deleteGroupClip, onCollapseClipsGroupOpen, deleteClip, addClipGroup, loadClip, selectedGroupClipdId}: groupClipsProps)
{

    const theme = useTheme();
    const [popoverOpen, setPopoverOpen] = useState<boolean>(false);

    const {information} = useMamInformation();
    const {setInformation} = useMamInformation();

    const {addClips, deleteSpecificClips, isClipGroupInContext, clips, aspectRatio} = useClipMamSelected();

    const [errorMessage, setErrorMessage] = useState<boolean>(false);
    const [numberSkeleton, setNumberSkeleton] = useState<Number[]>(new Array(6).fill(0));




    const handleMainCardClick = () => {
        setPopoverOpen(prevState => {return !prevState});
        onCollapseClipsGroupOpen(groupClip.competition, groupClip.event_id, groupClip.id, popoverOpen)


        }

        const addClip = (id: string) => {

            const clipInContext = clips.find(c => c.id === id);



            if (clipInContext) {
               deleteSpecificClips(id)
            }else {
                const item = information?.clip.filter(item => (item.id === id && item.aspect_ratio === aspectRatio));
                if (item && item.length > 0) {
                    addClips(item);
                }else{
                    setErrorMessage(true);
                }

            }

}

    return(
        <Box sx={{ position: 'relative' }}>


            <ErrorSnackBar  autoHideDuration={2000} open={errorMessage} setClose={() => {setErrorMessage(prevState => !prevState)}} errorMessage={"It is not possible to select a clip with a different format than the one selected"} />

        <CardClipComponent groupClip={groupClip} isChecked={isClipGroupInContext(groupClip.id)} deleteClip={deleteGroupClip} handleVideoPlayerURL={handleVideoPlayerUrl} handleOpenVideoPlayerURL={handleOpenVideoPlayerUrl} addGroupClip={addClipGroup}/>




            {groupClip.videoContentProduced === 1 ?
                (
                    <IconButton
                        size="small"
                        onClick={(event) => {
                            event.stopPropagation();
                            handleMainCardClick()
                        }}
                        sx={{
                            position: 'absolute',
                            top: '0px',
                            right: '0px',
                            backgroundColor: 'transparent',
                            width: '40px',
                            height: '40px',
                        }}
                    >
                        <CropSquareIcon
                            sx={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                color: 'white'
                            }}
                        />
                    </IconButton>
                ) : (groupClip.videoContentProduced === 2) ? (
                    <IconButton
                        size="small"
                        onClick={(event) => {
                            event.stopPropagation();
                            handleMainCardClick()
                        }}
                        sx={{
                            position: 'absolute',
                            top: '0px',
                            right: '0px',
                            backgroundColor: 'transparent',
                            width: '40px',
                            height: '40px',
                        }}
                    >
                        <FilterNoneIcon
                            sx={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                color: 'white'
                            }}
                        />
                    </IconButton>
                ) :  (groupClip.videoContentProduced >= 3) ? (
                    <AutoAwesomeMotionOutlinedIcon
                        onClick={(event) => {
                            event.stopPropagation();
                            handleMainCardClick()
                        }}
                        sx={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            color: 'white',
                            transform: 'rotate(180deg)'
                        }}
                    />
                ) : (
                    <></>
                )


            }
            <StyledPopup isOpen={popoverOpen} onClose={handleMainCardClick}>
                <Typography variant="h6" sx={{ marginTop: `${theme.spacing.md}`, color: `${theme.palette.white}` }}>
                    Available clips
                </Typography>
                <Grid container spacing={2} sx={{ mt: 1 }}>

                    { loadClip ? (
                        numberSkeleton.map((item, index) => (
                            <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
                                <ContentCardSkeleton/>
                            </Grid>
                        ))
                    ) : (
                        information?.clip !== undefined && information?.clip.filter(item => item.groupId === selectedGroupClipdId).map((variant: any) => {

                            return (

                                <Grid item xs={2} >
                                    <ClipComponent originalVideoContent={groupClip.editorClip} clip={variant} handleVideoPlayerUrl={handleVideoPlayerUrl} handleOpenVideoPlayerUrl={handleOpenVideoPlayerUrl} deleteClip={deleteClip} addClipGroup={addClip}/>
                                </Grid>
                            );
                        })
                    )

                    }

                </Grid>
            </StyledPopup>


            </Box>
    )
}